export const quotes = [
  {
    quote: `Let us prepare our minds as if we’d come to the very end of life.
    Let us postpone nothing. Let us balance life’s books each day.
    …The one who puts the finishing touches on their life each day is never short of time.`,

    person: 'Seneca'
  }
]
